import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Slider, VideoPlayer, NamedLink } from '../../components';
import { createSlug } from '../../util/urlHelpers';
import classNames from 'classnames';

import css from './ListingPage.module.css';

// slidesToShow
const SLIDES_TO_SHOW_TABLET = 3;
const SLIDES_TO_SHOW_DESKTOP = 3;
// slidesToScroll
const SLIDES_TO_SCROLL_TABLET = 1;
const SLIDES_TO_SCROLL_DESKTOP = 1;

// VideoPlayer settings
const VIDEO_PLAYER_SETTINGS = {
  bigPlayButton: true,
};

const SectionHighlightsMaybe = props => {
  const { intl, videos, isMobileLayout } = props;

  if (!videos || videos.length === 0) {
    return null;
  }

  const sliderTitle = intl.formatMessage(
    { id: 'ListingPage.highlightsTitle' },
    { count: videos.length }
  );

  return (
    <div
      className={classNames(css.sectionHighlights, {
        [css.sectionHighlightsHidden]: videos.length === 0,
      })}
    >
      <div className={css.highlights}>
        <Slider
          id="SectionHighlights"
          title={sliderTitle}
          headerClassName={css.sliderHeader}
          titleClassName={css.highlightsTitle}
          itemsClassName={css.highlightsSliderItems}
          arrowsClassName={css.highlightsSliderArrows}
          // Responsive slider settings
          slidesToShow={{
            tablet: SLIDES_TO_SHOW_TABLET,
            desktop: SLIDES_TO_SHOW_DESKTOP,
          }}
          slidesToScroll={{
            tablet: SLIDES_TO_SCROLL_TABLET,
            desktop: SLIDES_TO_SCROLL_DESKTOP,
          }}
        >
          {videos.map(video => {
            return (
              <div key={video.id} className={css.videoPlayerWrapper}>
                <VideoPlayer
                  controlTextClassName={css.videoPlayerControlText}
                  video={video}
                  settings={{ ...VIDEO_PLAYER_SETTINGS, playerTime: !isMobileLayout }}
                />
                <div className={css.videoTitle}>
                  <FormattedMessage
                    id="ListingPage.videoTitle"
                    values={{
                      title: (
                        <NamedLink
                          name="LiveRoomPage"
                          params={{
                            id: video.listing.id,
                            slug: createSlug(video.listing.title),
                          }}
                        >
                          {video.listing.title}
                        </NamedLink>
                      ),
                    }}
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default SectionHighlightsMaybe;
